import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// MUI
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import 'bootstrap/dist/css/bootstrap.min.css';
// Core components
import SoftBox from "components/SoftBox";

// Themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// RTL
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Routes + Context
import routes from "routes";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Assets
import brand from "assets/images/logo-ct.png";

// Pages
import HealthcareInfrastructureDashboard from "pages/Dashboard/HealthcareInfrastructureDashboard";
import NCDDashboard from "pages/Dashboard/NCDDashboard"
import MaternalHealthDashboard from "pages/Dashboard/MaternalHealthDashboard";
import HealthIntelligenceDashboard from "pages/Dashboard/HealthIntelligenceDashboard";
import MotherChildHealthCareDashboard from "pages/Dashboard/MotherChildHealthCareDashboard";
import Dashboard from "pages/Dashboard/Dashboard";
import RmnchDashboard from "pages/Dashboard/RMNCH";
import IntegratedHealthDashboard from "pages/Dashboard/StateHealthAnalyticsDashboard";
export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // RTL cache
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []);

  // Expand sidenav on hover
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Toggle configurator
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Update direction
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Scroll to top on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route) return <Route path={route.route} element={route.component} key={route.key} />;
      return null;
    });

  const configsButton = (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default">settings</Icon>
    </SoftBox>
  );

  const LayoutWrapper = ({ children }) => (
    <>
      {layout === "dashboard" && (
        <>
          {/* {configsButton} */}
        </>
      )}
      {layout === "vr"}
      {children}
    </>
  );

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={themeRTL}>
        <CssBaseline />
        <LayoutWrapper>
          <Routes>
            {getRoutes(routes)}
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/" element={<Navigate to="/Dashboard" replace />} />
            <Route path="/NCDDashboard" element={<NCDDashboard />} ></Route>
            <Route path="/MaternalHealthDashboard" element={<MaternalHealthDashboard />} ></Route>
            <Route path="/HealthIntelligenceDashboard" element={<HealthIntelligenceDashboard />} ></Route>
            <Route path="/MotherChildHealthCareDashboard" element={<MotherChildHealthCareDashboard />} ></Route>
            <Route path="/healthcare-infrastructure-dashboard" element={<HealthcareInfrastructureDashboard />} ></Route>
            <Route path="/RMNCH-Dashboard" element={<RmnchDashboard />} ></Route>
            <Route path="/IntegratedHealthDashboard" element={<IntegratedHealthDashboard />} ></Route>
          </Routes>
        </LayoutWrapper>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LayoutWrapper>
        <Routes>
          {getRoutes(routes)}
          <Route path="/healthcare-infrastructure-dashboard" element={<HealthcareInfrastructureDashboard />} />
          {/* <Route path="/executive-dashboard" element={<ExecutiveDashboard />} /> */}
          <Route path="*" element={<Navigate to="/healthcare-infrastructure-dashboard" replace />} />
        </Routes>
      </LayoutWrapper>
    </ThemeProvider>
  );
}
